
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class DeviceController extends Vue {
    arrayStream: MediaStream[];
    arrayVideoStream: HTMLVideoElement[];
    arrayAudioStream: MediaStream[];
    mounted(): void {
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO") {
            console.log("DeviceController mounted");
        }
        this.arrayStream = [];
        this.arrayVideoStream = [];
        this.arrayAudioStream = [];
    }
    addStream(stream: MediaStream) {
        this.arrayStream?.push(stream);
    }
    addVideoStream(stream: HTMLVideoElement) {
        this.arrayVideoStream?.push(stream);
    }
    addAudioStream(stream: MediaStream) {
        this.arrayAudioStream?.push(stream);
    }
    checkDevicesActive() {
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO") {
            console.log("DeviceController checkDevicesActive");
        }
        this.arrayStream.forEach(element => {
            if (process.env.VUE_APP_ENVIRONMENT !== "PRO") {
                console.log("DeviceController checkDevicesActive element ", element);
            }
            element.getVideoTracks().forEach((track) => {
                track.stop();
                element?.removeTrack(track);
                track = null;
            });

            element.getTracks().forEach((track) => {
                track.stop();
                element.removeTrack(track);
                track = null;
            });
        });

        this.arrayStream = [];

        navigator.mediaDevices.getUserMedia({ audio: true, video: true })
            .then(stream => {
                if (process.env.VUE_APP_ENVIRONMENT !== "PRO") {
                    console.log("DeviceController checkDevicesActive stream ", stream);
                }
                stream.getVideoTracks().forEach((track) => {
                    track.stop();
                    stream?.removeTrack(track);
                    track = null;
                });
    
                stream.getTracks().forEach((track) => {
                    track.stop();
                    stream.removeTrack(track);
                    track = null;
                });
            })
            .catch((err) => {
                console.log(err);
            });
    }
    removeVideoStream(): void {
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO") {
            console.log("DeviceController removeVideoStream");
        }
        this.arrayVideoStream.forEach(element => {
            if (element) {
                if (element.srcObject instanceof MediaStream)
                    element.srcObject.getVideoTracks().forEach((track) => {
                        track.stop();
                        track = null;
                    });
                element.currentTime = 0;
                element.srcObject = null;
                element.ended;
                element.remove();
                element = null;
            }
        });

        this.arrayVideoStream = null;
    }
    removeAudioStream(): void {
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO") {
            console.log("DeviceController removeAudioStream");
        }
        this.arrayAudioStream.forEach(element => {
            if (element) {
                element.getTracks()?.forEach((track) => {
                    track.stop();
                    element?.removeTrack(track);
                    track = null;
                });
                element = null;
            }
        });

        this.arrayAudioStream = null;
    }
}
